'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _basket = require('redux/actions/basket');

var _modal = require('redux/actions/modal');

var _helpers = require('helpers');

var _components2 = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PostponeBasket: {
        displayName: 'PostponeBasket'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/PostponeBasket/PostponeBasket.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PostponeBasket = _wrapComponent('PostponeBasket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        return dispatch((0, _basket.getPostpone)());
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        wishProducts: state.wishList.wishProducts,
        items: state.basket.itemsPostpone,
        lang: state.lang,
        preload: state.basket.preload,
        currency: state.currency
    };
}, { addProduct: _basket.addProduct, clearBasket: _basket.clearBasket, getPostpone: _basket.getPostpone, deletePostpone: _basket.deletePostpone, showModal: _modal.showModal, hide: _modal.hide, mergePostpone: _basket.mergePostpone, push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PostponeBasket, _Component);

    function PostponeBasket(props) {
        (0, _classCallCheck3.default)(this, PostponeBasket);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostponeBasket.__proto__ || (0, _getPrototypeOf2.default)(PostponeBasket)).call(this, props));

        _this.onDelete = function (id) {
            var lang = _this.props.lang;


            var modalContent = _react3.default.createElement(
                'div',
                { className: 'row no-margin' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    lang['store.postpone.deletePostpone.confirm']
                )
            );

            _this.props.showModal({
                title: lang['store.wish_list.remove'],
                content: modalContent,
                titleSuccess: lang['store.common.yes'],
                titleClose: lang['store.common.no'],
                onSuccess: function onSuccess() {
                    _this.props.deletePostpone(id);
                    // setTimeout(this.props.setWishList(storage.getItem('wishlist.common')), 50000);
                },
                modalType: 'del'
            });
        };

        _this.mergeBaskets = function () {
            var postponeIds = [];
            _this.state.selected.forEach(function (item, i) {
                if (item === true) {
                    postponeIds.push(i);
                }
            });
            _this.props.mergePostpone(postponeIds);
        };

        _this.inBasket = function (products) {
            _this.props.clearBasket();
            products.map(function (product) {
                _this.props.addProduct(product);
            });
            _this.props.push('/basket');
        };

        _this.inBasketMerged = function (childrenPostpone) {
            _this.props.clearBasket();
            var products = null;

            childrenPostpone.forEach(function (item, index) {
                products = JSON.parse(item.items_data);
                products.forEach(function (product) {
                    product.basket_number = index;
                    _this.props.addProduct(product);
                });
            });
            _this.props.push('/basket');
        };

        _this.changeSelected = function (e) {
            _this.state.selected[e.target.id] = e.target.checked;
            var countSelected = 0;
            _this.state.selected.forEach(function (item) {
                if (item === true) {
                    countSelected++;
                }
            });
            _this.setState({ countSelected: countSelected });
        };

        var selected = [];
        props.items.map(function (item) {
            selected[item.id] = false;
        });
        _this.state = {
            selected: selected,
            countSelected: 0
        };
        return _this;
    }

    (0, _createClass3.default)(PostponeBasket, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('PostponeBasket');
            var orderInOneClick = this.props.setting;
            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                _react3.default.createElement(View, {
                    products: this.props.wishProducts,
                    onDelete: this.onDelete,
                    inBasket: this.inBasket,
                    inBasketMerged: this.inBasketMerged,
                    orderInOneClick: orderInOneClick,
                    lang: this.props.lang,
                    currency: this.props.currency,
                    items: this.props.items,
                    changeSelected: this.changeSelected,
                    selected: this.state.selected,
                    countSelected: this.state.countSelected,
                    mergeBaskets: this.mergeBaskets
                })
            );
        }
    }]);
    return PostponeBasket;
}(_react2.Component), _class2.propTypes = {
    wishProducts: _react2.PropTypes.array,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp)) || _class) || _class));

exports.default = PostponeBasket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PostponeBasket/PostponeBasket.jsx
// module id = 1839
// module chunks = 0